
    // Winter / summer package tabs
    document.querySelectorAll('.season-tab').forEach(tab => {
      tab.addEventListener('click', () => {
        const season = tab.dataset.season;
        document.querySelectorAll('.season-tab').forEach(t => t.classList.toggle('active', t === tab));
        document.querySelectorAll('.season-panel').forEach(p => p.classList.toggle('active', p.dataset.season === season));
        gtag('event', 'select_content', { content_type: 'season_tab', item_id: season });
      });
    });
  